"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
var _Form = _interopRequireDefault(require("react-jsonschema-form/lib/components/Form"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WheelCell = /*#__PURE__*/function (_react$default$Compon) {
  function WheelCell() {
    var _this2;
    _classCallCheck(this, WheelCell);
    _this2 = _callSuper(this, WheelCell);
    _this2.state = {
      rotation: 0,
      opacity: 1,
      class: 'tsku-wheel-img tsku-rotate',
      formData: {},
      timer: 3,
      timerVisible: false,
      prize: null,
      prize_uri: null,
      angle: 0,
      eventType: "wheel play"
    };
    return _this2;
  }
  _inherits(WheelCell, _react$default$Compon);
  return _createClass(WheelCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "areRequiredFieldsOk",
    value: function areRequiredFieldsOk(fields, formData) {
      var requiredFields = fields.filter(function (field) {
        return field.required;
      });
      var _iterator = _createForOfIteratorHelper(requiredFields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (!formData[field.name] || formData.type === 'email' && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData[field.name])) return false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
  }, {
    key: "playGame",
    value: function playGame(backEndUri, game, default_prize_id, offset, slots, formData, sound_uri, uriTransformer) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.setState({
                opacity: 0,
                class: 'tsku-wheel-img'
              });
              setTimeout(function () {
                _this.setState({
                  timerVisible: true
                });
              }, 20);
              setTimeout(function () {
                _this.setState({
                  timer: 3
                });
              }, 20);
              setTimeout(function () {
                _this.setState({
                  timer: 2
                });
              }, 1020);
              setTimeout(function () {
                _this.setState({
                  timer: 1
                });
              }, 2020);
              setTimeout(function () {
                _this.setState({
                  timer: 'GO!'
                });
              }, 3020);
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var sound, audio, res, gain_win_id, _iterator2, _step2, _prize, _iterator3, _step3, prize, _iterator4, _step4, _prize2, _t2;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _this.setState({
                        timer: '',
                        timerVisible: false
                      });
                      sound = uriTransformer("https://treeoskiframes.website/wheel_sound/wheel_sound.mp3");
                      audio = new Audio(sound);
                      audio.play();
                      _context.p = 1;
                      _context.n = 2;
                      return _axios.default.post(backEndUri + '/play/' + game.id, {
                        player_data: formData
                      });
                    case 2:
                      res = _context.v;
                      gain_win_id = res.data.gain.id;
                      _iterator2 = _createForOfIteratorHelper(game.prizes);
                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          _prize = _step2.value;
                          if (gain_win_id === _prize.id) {
                            _this.setState({
                              prize: _prize
                            });
                          }
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                      if (!_this.state.prize) {
                        _context.n = 3;
                        break;
                      }
                      _this.setRotation(_this.state.prize.slot_index, offset, game, slots);
                      return _context.a(2);
                    case 3:
                      _iterator3 = _createForOfIteratorHelper(game.prizes);
                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          prize = _step3.value;
                          if (default_prize_id === prize.id) {
                            _this.setState({
                              prize: prize
                            });
                          }
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                      if (_this.state.prize) {
                        _this.setRotation(_this.state.prize.slot_index, offset, game, slots);
                      }
                    case 4:
                      console.log({
                        audio: audio
                      });
                      _context.n = 6;
                      break;
                    case 5:
                      _context.p = 5;
                      _t2 = _context.v;
                      _iterator4 = _createForOfIteratorHelper(game.prizes);
                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          _prize2 = _step4.value;
                          if (default_prize_id === _prize2.id) {
                            _this.setState({
                              prize: _prize2
                            });
                          }
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }
                      if (_this.state.prize) {
                        _this.setRotation(_this.state.prize.slot_index, offset, game, slots);
                      }
                    case 6:
                      _this.setState({
                        class: 'tsku-wheel-img'
                      });
                      audio.play();
                      console.log(game);
                    case 7:
                      return _context.a(2);
                  }
                }, _callee, null, [[1, 5]]);
              })), 4520);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "setRotation",
    value: function setRotation(slot_index, offset, game, slots) {
      var _this3 = this;
      var elementId = 'wheel-' + game.id;
      var element = document.getElementById(elementId);
      if (!element) {
        console.error("Element with ID", elementId, "not found.");
        return;
      }
      setTimeout(function () {
        _this3.setState({
          prize_uri: _this3.state.prize.image_uri
        });
      }, 12500);
      var angle = 360 * 8 + 360 / slots * slot_index + 4 + offset;
      console.log("Angle:", angle);
      element.style.transitionDuration = '16s';
      element.style.transform = 'rotate(' + angle + 'deg)';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        defaultLanguage = _this$props.defaultLanguage,
        cell = _this$props.cell,
        uriTransformer = _this$props.uriTransformer,
        intl = _this$props.intl,
        page = _this$props.page,
        project = _this$props.project,
        logEvent = _this$props.logEvent;
      var backEndUri = '';
      if (project) {
        backEndUri = project.backEndUri;
      }
      var formData = this.state.formData;
      var visibleFields = cell.fields.filter(function (field) {
        return field.visible;
      });
      var maleLabel = intl.formatMessage({
        id: 'email_form.gender.male'
      });
      var femaleLabel = intl.formatMessage({
        id: 'email_form.gender.female'
      });
      var otherGenderLabel = intl.formatMessage({
        id: 'email_form.gender.other'
      });
      var schema = {
        type: "object",
        required: visibleFields.filter(function (field) {
          return field.required;
        }).map(function (field) {
          return field.name;
        }),
        properties: visibleFields.reduce(function (acc, field) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, field.name, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            type: WheelCell.schemaFieldType(field.type),
            title: (0, _utils.i18nData)(field, "label", intl, defaultLanguage)
          }, field.type === "integer" ? {
            minimum: 1
          } : {}), field.type === "select" ? {
            enum: field.options.map(function (option) {
              return option.name;
            }),
            enumNames: field.options.map(function (option) {
              return (0, _utils.i18nData)(option, 'label', intl, defaultLanguage);
            })
          } : {}), field.type === "multiple_choices" && field.options.length > 0 ? {
            anyOf: field.options.map(function (option) {
              return {
                const: option.name,
                title: (0, _utils.i18nData)(option, 'label', intl, defaultLanguage)
              };
            })
          } : {}), field.type === "gender" ? {
            anyOf: [{
              const: "male",
              title: maleLabel
            }, {
              const: "female",
              title: femaleLabel
            }, {
              const: "other",
              title: otherGenderLabel
            }]
          } : {})));
        }, {})
      };
      var uiSchema = visibleFields.reduce(function (acc, field) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, field.name, _objectSpread(_objectSpread(_objectSpread({
          "ui:options": _objectSpread({
            "label": field.type === "gender"
          }, field.type === "email" ? {
            inputType: "email"
          } : {}),
          "ui:placeholder": (0, _utils.i18nData)(field, "label", intl, defaultLanguage),
          classNames: "tsku-form-".concat(field.type).concat(field.half_width ? ' tsku-form-half_width' : '')
        }, field.type === "integer" ? {
          "ui:widget": "updown"
        } : {}), field.type === "gender" || field.type === "multiple_choices" && field.options.length > 0 ? {
          "ui:widget": "radio"
        } : {}), field.type === "select" ? {
          "ui:widget": "select"
        } : {})));
      }, {
        "ui:order": visibleFields.map(function (field) {
          return field.name;
        })
      });
      var wheel_uri = uriTransformer(cell.wheel_uri);
      if (!wheel_uri) return null;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n        .form_".concat(cell.id, " .field-string.tsku-form-half_width {\n          width: -webkit-fill-available;\n        }\n      }\n      \n      .form_").concat(cell.id, " * {\n        font-family: \"").concat(cell.font, "\";\n      }\n      \n      .form_").concat(cell.id, " label {\n        color: ").concat(cell.text_form_color, " !important;\n        margin-top: 2em !important;\n      }\n      \n      .form_").concat(cell.id, " input[type=text],\n      .form_").concat(cell.id, " input[type=number],\n      .form_").concat(cell.id, " input[type=email] {\n        background-color: white;\n        color: ").concat(cell.text_form_color, ";\n        padding: 0.3em;\n        border: 2px solid ").concat(cell.text_form_color, ";\n        border-radius: 0.5em;\n        width: -webkit-fill-available;\n      }\n      \n      .form_").concat(cell.id, " input[type=text],\n      .form_").concat(cell.id, " input[type=number],\n      .form_").concat(cell.id, " input[type=email] {\n        background-color: white;\n        color: ").concat(cell.text_form_color, ";\n        padding: 0.3em;\n        border: 2px solid ").concat(cell.border_form_color, ";\n        border-radius: 0.5em;\n        width: -webkit-fill-available;\n      }\n      \n      .form_").concat(cell.id, " input[type=radio] {\n        width: 0.7em !important;\n        height: 0.7em !important;\n        margin: 0.68em !important;            \n      }\n      \n      .form_").concat(cell.id, " input[type=checkbox] {\n        width: 0.8em !important;\n        height: 0.8em !important;\n        margin-top: 0.28em !important;\n      }\n      \n      .form_").concat(cell.id, " select{\n        color: ").concat(cell.text_form_color, ";\n        border: 2px solid ").concat(cell.border_form_color, ";\n        background-color: white;\n        border-radius: 0.5em;\n        padding: 0.3em;\n        width: 100%;\n        font-size: 1em;\n      }\n      \n      .form_").concat(cell.id, " .btn-info {\n        color: ").concat(cell.text_form_color, ";\n        border: 2px solid ").concat(cell.border_form_color, ";\n        background-color: ").concat(cell.text_form_color, ";\n        font-size: 1em;\n      }\n      \n      /* Style lorsque le bouton radio est coch\xE9 */\n      input[type=radio]:checked {\n        background-color: white !important; /* Changer la couleur de fond */\n        color: ").concat(cell.text_form_color, " !important; /* Changer la couleur de fond */\n      }\n      \n      .form_").concat(cell.id, " .tsku-confirmation-msg {\n        color: ").concat(cell.text_form_color, ";\n        text-align: start;\n        margin-left: 2em;\n      }\n      \n      .form_").concat(cell.id, " .tsku-error-msg {\n        color: ").concat(cell.text_form_color, ";\n        text-align: start;\n        margin-left: 2em;\n      }\n      \n      .form_").concat(cell.id, " .control-label{\n        margin-top: 1.6em !important;\n        margin-bottom: 0.6em !important;\n        font-size: 1.4em !important;\n      }\n      \n      .form_").concat(cell.id, " input{\n        margin-bottom: 0.4em !important;\n      }\n      \n      label .control-label{\n        margin-top: 1.6em !important;\n        margin-bottom: 0.6em !important;\n      }\n      \n      .form_").concat(cell.id, " label{\n        margin-bottom: 1.2em !important;\n        margin-top: 1.2em !important;\n      }\n      \n      ")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: _objectSpread({
          position: 'relative',
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }, this.props.style)
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          zIndex: 5,
          fontSize: '5em',
          width: '100%',
          textAlign: 'center',
          color: cell.text_form_color,
          marginTop: '3em',
          position: 'absolute'
        }
      }, this.state.timerVisible ? this.state.timer : ''), /*#__PURE__*/_react.default.createElement("img", {
        id: 'wheel-' + cell.game.id,
        src: wheel_uri,
        style: _objectSpread(_objectSpread({
          transitionDuration: '12s',
          position: 'absolute',
          width: '100%',
          height: 'auto',
          objectFit: 'cover'
        }, this.props.style), {}, {
          zIndex: 2
        }),
        className: this.state.class
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          objectFit: 'cover',
          position: 'relative',
          margin: 'auto',
          width: '60%',
          padding: '6%',
          borderRadius: '0.4em',
          top: '10%',
          zIndex: 10,
          transitionDuration: '1s',
          display: this.state.opacity == 0 ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer(this.state.prize_uri),
        width: '100%'
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          objectFit: 'cover',
          position: 'relative',
          margin: 'auto',
          width: '80%',
          background: cell.background_form_color,
          border: 'solid 0.2em ' + cell.border_form_color,
          padding: '6%',
          borderRadius: '0.4em',
          top: '18%',
          zIndex: 3,
          transitionDuration: '1s',
          display: this.state.opacity == 1 ? 'block' : 'none',
          animation: 'none'
        }
      }, /*#__PURE__*/_react.default.createElement(_Form.default, {
        formData: formData,
        autocomplete: "off",
        noHtml5Validate: true,
        showErrorList: false,
        noValidate: true,
        className: "form_".concat(cell.id, " tsku-form"),
        schema: schema,
        uiSchema: _objectSpread(_objectSpread({}, uiSchema), {}, {
          "ui:rootFieldId": "form_".concat(cell.id)
        }),
        onSubmit: function onSubmit(_ref, e) {
          var formData = _ref.formData;
          e.preventDefault();
          _this4.setState({
            formData: formData,
            success: true,
            error: false
          });
          if (!_this4.areRequiredFieldsOk(visibleFields, formData)) {
            _this4.setState({
              success: false,
              error: true
            });
          } else {
            _this4.playGame(backEndUri, cell.game, cell.default_prize_id, cell.offset, cell.slots, formData, cell.sound_uri, uriTransformer);
            var data = _objectSpread({
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale
            }, formData);
            logEvent(_this4.state.eventType, data);
          }
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "tsk-err-msg"
      }, this.state.error ? 'Veuillez remplir tous les champs' : ''), /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "tsku-btn-wheel",
        style: {
          background: cell.background_form_color,
          marginTop: '0.2em',
          fontSize: '2em',
          width: '100%',
          borderRadius: '0.2em',
          textAlign: 'center',
          border: 'solid 0.2em ' + cell.border_form_color,
          color: cell.text_form_color
        }
      }, "Play")))));
    }
  }], [{
    key: "schemaFieldType",
    value: function schemaFieldType(type) {
      switch (type) {
        case "short_text":
        case "long_text":
        case "email":
        case "gender":
        case "multiple_choices":
        case "select":
          return "string";
        case "integer":
          return "integer";
        case "checkbox":
          return "boolean";
        default:
          throw new Error("Unknown field type: ".concat(type));
      }
    }
  }]);
}(_react.default.Component);
_defineProperty(WheelCell, "whyDidYouRender", true);
_defineProperty(WheelCell, "defaultProps", {
  uriTransformer: function uriTransformer(u) {
    return u;
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(WheelCell);